<template>
  <nav v-if="userUUID && clubUUID" class="sidebar">
    <div class="sidebar-header">
      <div class="row w-100  d-flex justify-content-center align-items-center mb-1 mt-1">
        <div class="col-md-12 text-center">
          <router-link :to="{ name: 'dashboard', params: { clubUUID: clubUUID } }" class="bg-none">
            <img src="@/assets/img/logo-black.png" alt="store" style="width: 120px;">
          </router-link>
          <div>

            <span>{{ user?.firstName || '' }} {{ user?.lastName || '' }}</span>

          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-body">
      <ul class="nav mb-5" style="padding-bottom: 45px !important;">
        <li v-if="hasPermission('scan_qr_code')" class="nav-item  fixed-scanner">
          <scanner-qr-code />
        </li>
        <li class="nav-item mb-2" v-if="hasPermission('acces_rapide')"
          :class="{ 'margin-top-109': hasPermission('scan_qr_code') }">
          <router-link :to="{ name: 'access-rapide', params: { clubUUID: clubUUID } }" class="nav-link">
            <font-awesome-icon icon="jet-fighter-up" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.accesRapid') }}</span>
          </router-link>
        </li>

        <li class="nav-item mb-2" v-if="hasPermission('dashboard')">
          <router-link :to="{ name: 'dashboard', params: { clubUUID: clubUUID } }" class="nav-link">
            <font-awesome-icon icon="dashboard" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.dashboard') }}</span>
          </router-link>
        </li>


        <!--  prospects members -->
        <li class="nav-item mb-2" v-if="hasPermission('prospection_view') || hasPermission('prospection_view')">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#prospects-collapse" aria-expanded="false">
            <font-awesome-icon icon="users" size="lg" class="link-icon" />
            <span class="link-title "> {{ i18n.t('layout.sidbar.members.prospects') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>

          </a>
          <div class="collapse" id="prospects-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li v-if="hasPermission('prospection_create')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'create-prospection', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="user-plus" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.members.new_prospect') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('prospection_view')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'prospection', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.members.prospection_list') }} </span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!--   members -->
        <li class="nav-item mb-2" v-if="hasPermission('members')">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#members-collapse" aria-expanded="false">
            <font-awesome-icon icon="users" size="lg" class="link-icon" />
            <span class="link-title "> {{ i18n.t('layout.sidbar.members.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>

          </a>
          <div class="collapse" id="members-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li v-if="hasPermission('new_subscriptions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'inscription', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="user-plus" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.subscriptions.new_subscriptions') }}</span>
                </router-link>
              </li>

              <li v-if="hasPermission('members_list')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'members', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.members.members_list') }}</span>
                </router-link>
              </li>






              <li v-if="hasPermission('members_list')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'assurances-members', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.members.etat_assurances') }}</span>
                </router-link>
              </li>


              <li v-if="hasPermission('members_with_pointeuses_errors')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'members-with-pointeuses-errors', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.members.members_with_issues_pointeuses') }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>


        <!-- subscriptions members -->
        <li class="nav-item mb-2" v-if="hasPermission('subscriptions_members')">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#subscriptionsmembers-collapse" aria-expanded="false">
            <font-awesome-icon icon="check" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.subscriptions.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="subscriptionsmembers-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('active_subscriptions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'active-subscriptions', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="hourglass-start" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.subscriptions.active_subscriptions') }}</span>
                </router-link>
              </li>
              <li v-if="hasPermission('expired_subscriptions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'expired-subscriptions', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="hourglass-end" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.subscriptions.expired_subscriptions') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('subscriptions_expiring')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'subscriptions-expiring', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="hourglass-half" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.subscriptions.subscriptions_expiring') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('historiques_subscriptions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'historiques-subscriptions', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="history" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.subscriptions.historiques_subscriptions') }}
                  </span>
                </router-link>
              </li>
              <li v-if="hasPermission('credits')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'credits', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="hand-holding-dollar" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.credits') }}</span>
                </router-link>
              </li>
              <li v-if="hasPermission('renewal_status')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'members-renewed-status', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.members.renewal_status') }}</span>
                </router-link>
              </li>
              <li v-if="hasPermission('subscriptions_sold')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'packs-sales', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="chart-bar" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.subscriptions.subscriptions_sold') }} </span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Start employee -->
        <li v-if="hasPermission('trainers') || hasPermission('trainers_stats') || hasPermission('planned_sessions') || hasPermission('schedules_session')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#trainers-collapse" aria-expanded="false">
            <font-awesome-icon icon="users" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.trainers.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="trainers-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('trainers')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'trainers', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="users" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.trainers.trainers_list') }} </span>
                </router-link>
              </li>

              <li v-if="hasPermission('planned_sessions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'public-sessions', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="calendar-alt" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.trainers.session') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('schedules_session')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'schedules', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="calendar-alt" size="lg" class="link-icon" />
                  <span class="link-title"> Calendra </span>
                </router-link>
              </li>


            </ul>
          </div>
        </li>
        <!-- End employee -->

        <!-- start incomes (service complémentaires) -->
        <li v-if="hasPermission('incomes_list')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#incomes-collapse" aria-expanded="false">
            <font-awesome-icon icon="coins" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.incomes.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="incomes-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('incomes_list')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'incomes', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="store" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.incomes.list') }} </span>
                </router-link>
              </li>

            </ul>
          </div>
        </li>
        <!-- end incomes (service complémentaires) -->
        <!-- start expense (les charges) -->
        <li v-if="hasPermission('expenses_list')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#expenses-collapse" aria-expanded="false">
            <font-awesome-icon icon="coins" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.expenses.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="expenses-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('expenses_list')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'expenses', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="store" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.expenses.list') }} </span>
                </router-link>
              </li>

            </ul>
          </div>
        </li>
        <!-- end expense (les charges) -->
        <!-- Start Product -->
        <li v-if="hasPermission('view_stock_products') || hasPermission('view_stock_categories')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#stock-collapse" aria-expanded="false">
            <font-awesome-icon icon="store-alt" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.stock.product.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="stock-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li v-if="hasPermission('view_stock_categories')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'list-categories', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="tags" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.stock.product.categories') }} </span>
                </router-link>
              </li>

              <li v-if="hasPermission('view_stock_products')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'list-products', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="box" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.stock.product.products') }} </span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- End products -->



        <!-- Start Product -->
        <li v-if="hasPermission('view_stock_orders')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#orders-collapse" aria-expanded="false">
            <font-awesome-icon icon="store-alt" size="lg" class="link-icon" />
            <span class="link-title">
              {{ i18n.t('layout.sidbar.stock.order.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="orders-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('view_stock_orders')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'orders', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="receipt" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.stock.order.liste') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('create_stock_orders')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'stock-add-order', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="cart-plus" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.stock.order.add_order_product') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('create_stock_orders')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'stock-add-order-spa', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="spa" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.stock.order.add_order_service') }} </span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- End products -->








        <!-- regulations -->
        <li v-if="hasPermission('regulations')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#regulations-collapse" aria-expanded="false">
            <font-awesome-icon icon="money-check-dollar" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="regulations-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">


              <li v-if="hasPermission('transactions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'encaissements', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="file-invoice" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.encaissements') }}</span>
                </router-link>
              </li>
              <li v-if="hasPermission('payments_stats')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'reporting-cashflow-incomes', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="money-bill-trend-up" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.cashflow_encaissements') }} </span>
                </router-link>
              </li>

              <li v-if="hasPermission('transactions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'decaissements', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="file-invoice" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.decaissements') }}</span>
                </router-link>
              </li>

              <li v-if="hasPermission('payments_stats')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'reporting-cashflow-expenses', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="money-bill-trend-up" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.regulations.cashflow_decaissements') }} </span>
                </router-link>
              </li>

            </ul>
          </div>
        </li>




        <li v-if="hasPermission('ca')" class="nav-item mb-2">
          <router-link :to="{ name: 'global-revenu', params: { clubUUID: clubUUID } }" class="nav-link">
            <font-awesome-icon icon="chart-pie" size="lg" class="link-icon" />
            <span class="link-title">{{ i18n.t('layout.sidbar.subscriptions.ca') }} </span>
          </router-link>
        </li>
        <li v-if="hasPermission('reporting')" class="nav-item mb-2">
          <router-link :to="{ name: 'reporting', params: { clubUUID: clubUUID } }" class="nav-link">
            <font-awesome-icon icon="chart-pie" size="lg" class="link-icon" />
            <span class="link-title">{{ i18n.t('layout.sidbar.reporting.title') }}</span>
          </router-link>
        </li>
        <li v-if="hasPermission('business_insights')" class="nav-item mb-2">
          <router-link :to="{ name: 'business-insights', params: { clubUUID: clubUUID } }" class="nav-link">
            <font-awesome-icon icon="chart-line" size="lg" class="link-icon" />
            <span class="link-title">{{ i18n.t('layout.sidbar.regulations.business_insights') }} </span>
          </router-link>
        </li>
        <li v-if="hasPermission('sendmail') || hasPermission('whatssap_evolution')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#messages-collapse" aria-expanded="false">
            <font-awesome-icon icon="paper-plane" size="lg" class="link-icon" />
            <span class="link-title">Gestion de la messagerie
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="messages-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">


              <li v-if="hasPermission('whatssap_evolution')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'send-whatsapp', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="comment-dots" size="lg" class="link-icon" />
                  <span class="link-title"> Whatsapp</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <li v-if="hasPermission('presences_today') || hasPermission('history_presences')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#presences-collapse" aria-expanded="false">
            <font-awesome-icon icon="clock" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.presences.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="presences-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">

              <li v-if="hasPermission('presences_today')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'presences', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="sign-in-alt" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.presences.today') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('history_presences')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'hitoriques-presences', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="history" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.presences.history_presences') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('members_checkins')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'members-checkins', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="user-clock" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.presences.checkins') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('daily_attendance')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'daily-member-activity', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="fire" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.presences.daily_attendance') }} </span>
                </router-link>
              </li>

              <!-- <li v-if="hasPermission('history_presences')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'attendances-hikvision', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="history" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.presences.history_presences') }} </span>
                </router-link>
              </li> -->

            </ul>
          </div>
        </li>

        <!-- settings -->
        <li v-if="hasPermission('settings')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#settings-collapse" aria-expanded="false">
            <font-awesome-icon icon="gears" size="lg" class="link-icon" />
            <span class="link-title">{{ i18n.t('layout.sidbar.settings.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="settings-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li v-if="hasPermission('subscriptions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'subscriptions', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="shapes" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.subscriptions') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('packs')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'packs', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="trophy" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.packs') }} </span>
                </router-link>
              </li>

              <li v-if="hasPermission('fees')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'fees', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="money-bill" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.fees') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('assurances')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'assurances', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="briefcase-medical" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.assurances') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('promotions')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'promotions', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="gift" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.settings.promotions') }} </span>
                </router-link>
              </li>



              <li v-if="hasPermission('incomes')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'incomes-categories-services', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="store-alt" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.settings.incomes') }} </span>
                </router-link>
              </li>



              <li v-if="hasPermission('expenses')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'expenses-categories-services', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="store-alt" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.settings.expenses') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('announcements')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'announcements', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="tv" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.announcements') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('cash_journals')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'cash-journals', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="sack-dollar" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.settings.cash_journals') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('connect_whatsapp')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'whatsapp-connect', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="envelope" size="lg" class="link-icon" />
                  <span class="link-title"> Lier votre compte WhatsApp</span>
                </router-link>
              </li>
              <li v-if="hasPermission('settings_club')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'settings-club', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="gear" size="lg" class="link-icon" />
                  <span class="link-title"> Paramètres</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>


        <li v-if="hasPermission('manage_hikvision_pointeuses')" class="nav-item mb-2">
          <a class="nav-link nav-category align-items-center rounded collapsed" data-bs-toggle="collapse"
            data-bs-target="#pointeuseISAPI-collapse" aria-expanded="false">
            <font-awesome-icon icon="tablet-alt" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.pointeuses.title') }}
              <font-awesome-icon icon="chevron-right" size="sm" class="link-icon-arrow" />
            </span>
          </a>
          <div class="collapse" id="pointeuseISAPI-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li v-if="hasPermission('pointeuses')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'pointeuses', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="fingerprint" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.pointeuses.list') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('config_schedules_templates_shift')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'schedules-templates', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="calendar" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.pointeuses.schedules_templates') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('config_schedules_templates_shift')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'add-schedules-templates', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="calendar-plus" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.pointeuses.add_schedule_template') }} </span>
                </router-link>
              </li>

              <li v-if="hasPermission('manage_push_to_pointeuses')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'add-person-to-pointeuses', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="tablet-alt" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.pointeuses.manage_push_to_pointeuses') }} </span>
                </router-link>
              </li>
              <li v-if="hasPermission('manage_remove_from_pointeuses')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'delete-person-from-pointeuses', params: { clubUUID: clubUUID } }"
                  class="nav-link">
                  <font-awesome-icon icon="tablet-alt" size="lg" class="link-icon" />
                  <span class="link-title">{{ i18n.t('layout.sidbar.pointeuses.manage_remove_from_pointeuses') }}
                  </span>
                </router-link>
              </li>


              <li v-if="hasPermission('test_connection_raspberry')" class="nav-item nav-item-ml">
                <router-link :to="{ name: 'test-connection', params: { clubUUID: clubUUID } }" class="nav-link">
                  <font-awesome-icon icon="microchip" size="lg" class="link-icon" />
                  <span class="link-title"> {{ i18n.t('layout.sidbar.pointeuses.test_connection_raspberry') }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>


      </ul>
      <!-- <div class="call-us">
        <div>
          <div>
            <a href="tel:+212633402241">{{ i18n.t('gymya.phone') }}</a>
          </div>
          <div>
            <a href="mailto:contact@gymya.ma">{{ i18n.t('gymya.email') }}</a>
          </div>
        </div>
      </div> -->
    </div>
  </nav>
</template>

<script lang="ts">
import i18n from "@/i18n/index"
import { defineComponent, ref, computed } from 'vue';
import { useRoute } from "vue-router";
import { useGlobal } from "@/composables/global/useGlobal";
import { useDashboard } from '@/composables/dashboard/useDashboard';
import { usePermission } from "@/composables/auth/usePermission";
import { userUUID, clubUUID, currentClub, logoImage, signatureImage } from '@/shared/state';
import { userPermissions, user } from '@/shared/state';
export default defineComponent({
  name: 'SomeComponent',
  setup() {



    const userPermissionsList = computed(() => userPermissions.data);
    const { getDateRangeBefore,  getBase64Image,
      convertToBase64, } = useGlobal();
    const data = ref<any>(null);
    const error = ref<string | null>(null);
    const { fetchDefaultApi, getDashboardData } = useDashboard();
    const { hasPermission } = usePermission();
    const body = {
      "id": null,
      "is_paid": "",
      "end_date": "",
      "pack_id": null,
      "subscription_id": null,
      "clubUUID": clubUUID.value,
      "memberUUID": "",
      "memberName": "",
      "memberCIN": "",
      "gender": "",
      "isActive": "",
      "dueDate": getDateRangeBefore(3, 'month'),
      "type": "take",
      "page": null,
      "limit": 6,
      "with_transactions": "false",
      "with_subscription": "true",
      "with_pack": "true",
      "with_member": "true",
      "with_seller": "false",
      "summary": "false",
      "expiringSubscriptions": "true"
    }

    const getDefaultApi = async () => {
      error.value = null;
      try {
        const response = await fetchDefaultApi(body);
        data.value = response;
      } catch (err: any) {
        error.value = err.message;
      }
    };
    getDefaultApi()

    /***
     * Get data dashboard if routeName is diffrent dashboard
     */
    const route = useRoute();
    let routeName = route?.name ?? ''
    if (routeName.toString() !== "dashboard") {
      getDashboardData(body)
    }



    /** LOGO */
    
    // --- 3. Methods & Logic ---
    const createElementLogo = async () => {
      const { getInvoiceLogoPath } = await import("@/config/invoiceRegistry");
      const logoPath = getInvoiceLogoPath(currentClub.value);
      const imgUrl = logoPath
        ? logoPath.startsWith("http")
          ? logoPath
          : process.env.VUE_APP_URL + logoPath
        : "";

      if (!imgUrl) return;

      const base64 = await convertToBase64(imgUrl);
      const image = document.createElement("img");
      image.src = base64;
      logoImage.value = image;
    };

    createElementLogo();


    // --- 3. Methods & Logic ---
    const createElementSignatureImage = async () => {
      const { getInvoiceSignaturePath } = await import("@/config/invoiceRegistry");
      const signaturePath = getInvoiceSignaturePath(currentClub.value);
      const imgUrl = signaturePath
        ? signaturePath.startsWith("http")
          ? signaturePath
          : process.env.VUE_APP_URL + signaturePath
        : "";

      if (!imgUrl) return;

      const base64 = await convertToBase64(imgUrl);
      const image = document.createElement("img");
      image.src = base64;
      signatureImage.value = image;
    };

    createElementSignatureImage();


    return {
      data,
      error,
      // states 
      userPermissionsList,
      hasPermission,
      clubUUID,
      userUUID,
      currentClub,
      i18n,
      user
    };
  },
});
</script>

<style lang="scss" scoped>
.link-icon-arrow {
  width: 6px;
  margin-inline-start: 2px;
  top: 30%;
}

/*.margin-top-109{
  margin-top: 109px;
}

.fixed-scanner{
  position: fixed !important;
    z-index: 9999;
    width: 254px;
    background: gray;
}*/
</style>